import { Navigate } from 'react-router-dom';

// Legacy route: contact messages now live inside the Admin Console.
const AdminMessages = () => <Navigate to="/admin?tab=messages" replace />;

export default AdminMessages;
